import React from "react";
import "./Roadmap.css";

function Roadmap() {
  return (
    <div className="rm">
      <div className="container">
        <div className="rm__container">
          <ul className="rm__list">
            <li className="rm__item">
              <p className="rm__item-title">введи свое имя</p>
            </li>
            <li className="rm__item">
              <p className="rm__item-title">
                выбери цветы которые <br /> тебе нравятся
              </p>
            </li>
            <li className="rm__item">
              <p className="rm__item-title">
                отправь ему <br /> готовый текст..
              </p>
            </li>
            <li className="rm__item">
              <p className="rm__item-title">
                и.. просто <br /> подожди
              </p>
            </li>
          </ul>
        </div>
      </div>
    </div>
  );
}

export default Roadmap;
